import { forwardRef } from 'react';
import clsx from 'clsx';

import type { BoxProps } from '../Box/Box';
import { Box } from '../Box/Box';
import type { Props as TruncateProps } from '../private/Truncate/Truncate';
import { Truncate } from '../private/Truncate/Truncate';

import * as styles from './styles.css';

export type Props = React.PropsWithChildren &
  styles.Variants & {
    as?: BoxProps['as'];
    align?: BoxProps['textAlign'];
    color?: BoxProps['color'];
    decoration?: BoxProps['textDecoration'];
    display?: BoxProps['display'];
    lines?: TruncateProps['lines'];
    transform?: BoxProps['textTransform'];
    userSelect?: BoxProps['userSelect'];
    cssClass?: BoxProps['cssClass'];
    title?: string;
    whiteSpace?: BoxProps['whiteSpace'];
    wrap?: BoxProps['overflowWrap'];
  };

/** @deprecated use `Text` from `@launchpad-ui/components` instead. */
export const Text = forwardRef<unknown, Props>(
  (
    {
      as,
      children,
      color,
      decoration,
      display,
      lines,
      transform,
      userSelect,
      cssClass,
      title,
      whiteSpace,
      wrap,
      align,
      break: breakVariant,
      case: caseVariant,
      family,
      size,
      weight,
    },
    ref,
  ) => {
    const content = lines ? (
      <Truncate ref={ref} lines={lines}>
        {children}
      </Truncate>
    ) : (
      children
    );

    return (
      <Box
        as={as}
        color={color}
        cssClass={clsx(
          styles.variants({ align, break: breakVariant, case: caseVariant, family, size, weight }),
          cssClass,
        )}
        display={display}
        overflowWrap={wrap}
        ref={lines ? undefined : ref}
        textDecoration={decoration}
        textTransform={transform}
        title={title}
        userSelect={userSelect}
        whiteSpace={whiteSpace}
      >
        {content}
      </Box>
    );
  },
);

Text.displayName = 'Text';
